"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDJSONParserOption = void 0;
var TDJSONOption_1 = require("./TDJSONOption");
var TDJSONParserOption = /** @class */ (function (_super) {
    __extends(TDJSONParserOption, _super);
    function TDJSONParserOption() {
        var _this = _super.call(this) || this;
        // Package scopes used by parser
        _this.termValue = "";
        _this.termValueInMap = "";
        _this.termValueInArray = "";
        _this.termKey = "";
        _this.termValueStrs = [];
        _this.termKeyStrs = [];
        _this.buildTerms();
        return _this;
    }
    TDJSONParserOption.ofDefaultRootType = function (type) { return new TDJSONParserOption().setDefaultRootType(type); };
    TDJSONParserOption.ofMapToString = function () { return new TDJSONParserOption().setDeliminatorKey("=").setDeliminatorValue(", "); };
    TDJSONParserOption.prototype.setDefaultRootType = function (type) {
        this.defaultRootType = type;
        return this;
    };
    TDJSONParserOption.prototype.setDocId = function (id) {
        this.docId = id;
        return this;
    };
    TDJSONParserOption.prototype.setDeliminatorKey = function (val) { this.deliminatorKey = val; return this; };
    TDJSONParserOption.prototype.setDeliminatorValue = function (val) { this.deliminatorValue = val; return this; };
    TDJSONParserOption.prototype.setDeliminatorObject = function (start, end) {
        this.deliminatorObjectStart = start;
        this.deliminatorObjectEnd = end;
        return this;
    };
    TDJSONParserOption.prototype.setDeliminatorArray = function (start, end) {
        this.deliminatorArrayStart = start;
        this.deliminatorArrayEnd = end;
        return this;
    };
    TDJSONParserOption.prototype.buildTerms = function () {
        this.termValue = "\n\r" + this.deliminatorKey + this.deliminatorObjectStart; // support tree with a type in the form of "type{attr1:val1}", key1:key2:type{att1:val1}    
        this.termKey = this.deliminatorObjectStart + this.deliminatorObjectEnd + this.deliminatorArrayStart;
        this.termValueStrs = [];
        this.termKeyStrs = [];
        if (this.deliminatorValue.length === 1) { // If more than 1, will use separate string collection as term
            this.termValue += this.deliminatorValue;
            this.termKey += this.deliminatorValue;
        }
        else {
            this.termValueStrs.push(this.deliminatorValue);
            this.termKeyStrs.push(this.deliminatorValue);
        }
        if (this.deliminatorKey.length === 1)
            this.termKey += this.deliminatorKey;
        else
            this.termKeyStrs.push(this.deliminatorKey);
        this.termValueInMap = this.termValue + this.deliminatorObjectEnd + this.deliminatorArrayEnd; // It's possible object end is omitted for path compression. e.g [a:b:c]
        this.termValueInMap = this.termValue + this.deliminatorObjectEnd;
        this.termValueInArray = this.termValue + this.deliminatorArrayEnd;
    };
    return TDJSONParserOption;
}(TDJSONOption_1.TDJSONOption));
exports.TDJSONParserOption = TDJSONParserOption;
//# sourceMappingURL=TDJSONParserOption.js.map